import { Locale } from 'types';

export const recheckProcessTranslation = {
  [Locale.en]: {
    hello: 'Hello',
    thanks: 'Thanks!',
    yourEmail: 'Your email',
    verifyIdentity: 'Verify identity',
    identityVerificationSuccess: 'Identity Verification Success',
    repIdentityVerificationSuccess: 'Rep Identity Verification Success',
    repIdentityVerificationError: 'Rep Identity Verification Error',
    onboardingSalesRep: 'Thank you for on-boarding as a sales representative with Palmetto Finance.',
    recheckIdConnected:
      'Your Recheck ID has been connected to LightReach. Please close this page and continue working with this homeowner to go solar!',
    recheckIdNoConnected:
      'We were not able to link your Recheck ID with your LightReach project. If you started your Recheck sign up on a different device than this one, please return to that device and complete your Recheck sign up there. You may also use your LightReach email invitation to try again. We apologize for the inconvenience.',
    somethingWentWrong: 'Oops. Something went wrong.',
  },
  [Locale.es]: {
    hello: 'Hola',
    thanks: '¡Gracias!',
    yourEmail: 'Tu correo electrónico:',
    verifyIdentity: 'Verificar identidad',
    verifyIdentitySuccess: 'Identidad Verificada Exitosamente',
    repIdentityVerificationSuccess: 'Identidad del Representante verificada exitosamente',
    repIdentityVerificationError: 'Error de verificación de identidad del Representante',
    onboardingSalesRep: 'Gracias por unirse como representante de ventas con Palmetto Finance.',
    recheckIdConnected:
      'Su ID de Recheck ha sido conectado a LightReach. ¡Por favor, cierre esta página y continúe trabajando con este propietario para la energía solar!',
    recheckIdNoConnected:
      'No pudimos vincular su ID de Recheck con su proyecto LightReach. Si comenzó su registro de Recheck en un dispositivo diferente a este, regrese a ese dispositivo y complete su registro de Recheck allí. También puede usar su invitación por correo electrónico de LightReach para intentarlo nuevamente. Pedimos disculpas por los inconvenientes.',
    somethingWentWrong: 'Vaya. Algo salió mal.',
  },
};
